(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3577],{

/***/ 80367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ TextFieldWrapper; },
/* harmony export */   "Nl": function() { return /* binding */ TextFieldInput; },
/* harmony export */   "ns": function() { return /* binding */ TextFieldError; },
/* harmony export */   "pU": function() { return /* binding */ TextFieldLabel; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68777);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96861);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20881);
/* harmony import */ var _typography_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function TextField(_ref) {
  var type = _ref.type,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      error = _ref.error,
      placeholder = _ref.placeholder,
      initialValue = _ref.initialValue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(TextFieldWrapper, {
    "data-testid": "text-main-wrapper",
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldLabel, {
      "data-testid": "text-field-label",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
        htmlFor: name,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          type: "mode2",
          fw: "light",
          children: label
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldInput, {
      "data-testid": "text-field-wrapper",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread(_objectSpread({
        defaultValue: initialValue,
        type: type,
        id: name,
        "data-testid": "text-field",
        placeholder: placeholder
      }, register(name)), {}, {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
          invalid: Boolean(error)
        })
      }))
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldError, {
      "data-testid": "text-field-error",
      children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        type: "mode2",
        fw: "medium",
        children: error.message
      })
    })]
  });
}

var TextFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldWrapper",
  componentId: "sc-3wp9eq-0"
})(["&:not(:first-child){margin-top:24px;}@media ", "{&:not(:first-child){margin-top:20px;}}", ""], styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref2) {
  var inputVariant = _ref2.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["display:flex;"]);
});
var TextFieldLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldLabel",
  componentId: "sc-3wp9eq-1"
})(["display:flex;margin-bottom:8px;", " ", " > label{cursor:pointer;> p{color:", ";", "}}", ""], function (_ref3) {
  var inputVariant = _ref3.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["color:", ";margin-bottom:0;align-items:end;& > label > p{font-size:20px;font-weight:500;line-height:1 !important;@media ", "{font-size:17px !important;}}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.grayPallet9;
  }, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet);
}, function (_ref5) {
  var inputVariant = _ref5.inputVariant,
      disabled = _ref5.disabled;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> label{cursor:not-allowed;> p{color:", " !important;}}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.grayPallet18;
  });
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackPallet6;
}, function (_ref8) {
  var alignLeft = _ref8.alignLeft;
  return alignLeft ? 'text-align: left' : '';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> label{cursor:not-allowed;> p{color:", ";}}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.grayPallet18;
  });
});
var TextFieldInput = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldInput",
  componentId: "sc-3wp9eq-2"
})(["> input{height:55px;width:100%;border:1px solid ", ";background-color:", ";padding:16px 20px;font-weight:", ";color:", ";font-size:17px;line-height:23px;transition:200ms all ease;@media ", "{font-size:16px;}&::placeholder{color:", ";}&:hover{border-color:hsl(0,0%,70%);}&:focus{border:1px solid ", ";}&.invalid{border:1px solid ", ";}&:disabled,&:disabled:hover{border:1px solid ", ";color:", ";background-color:", ";}}", " ", " ", "{margin-top:5px;display:inline-block;text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grayPallet19;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.whitePallet3;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.blackPallet6;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.grayPallet18;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.green;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.redPallet3;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.grayPallet20;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.grayPallet30;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.grayPallet20;
}, function (_ref21) {
  var isTransparentBackground = _ref21.isTransparentBackground;
  return isTransparentBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> input{background-color:transparent;}"]);
}, function (_ref22) {
  var inputVariant = _ref22.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["& > input{height:auto;border:none;border-bottom:1px solid ", ";background-color:transparent;padding:0 10px;margin-left:7px;@media ", "{padding:0 5px;}&:hover{border:none;border-bottom:1px solid ", ";}&:focus{border:none;border-bottom:1px solid ", ";}&.invalid{border:none;border-bottom:1px solid ", ";}&:disabled,&:disabled:hover{border:none;border-bottom:1px solid ", ";color:", ";background-color:transparent;}}"], function (_ref23) {
    var theme = _ref23.theme;
    return theme.colors.black;
  }, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref24) {
    var theme = _ref24.theme;
    return theme.colors.black;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return theme.colors.green;
  }, function (_ref26) {
    var theme = _ref26.theme;
    return theme.colors.redPallet3;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.colors.grayPallet18;
  }, function (_ref28) {
    var theme = _ref28.theme;
    return theme.colors.grayPallet18;
  });
}, _typography_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Typography */ .Z.Typography);
var TextFieldError = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldError",
  componentId: "sc-3wp9eq-3"
})(["> p{color:", ";}& > span{font-size:12px;color:", ";}"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.red;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.red;
});
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TextField));

/***/ }),

/***/ 96861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "text__Text",
  componentId: "sc-1bgtwf9-0"
})(["text-transform:", ";text-decoration:", ";color:", ";", " ", ""], function (props) {
  return props.textTransform;
}, function (props) {
  return props.textDecoration;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackPallet1;
}, function (_ref2) {
  var fw = _ref2.fw;

  switch (fw) {
    case 'light':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Light;"]);

    case 'medium':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Medium;"]);

    case 'bold':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Bold;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Regular;"]);
  }
}, function (props) {
  switch (props.type) {
    case 'mode1':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode1.fontSize, props.theme.typography.texts.mode1.lineHeight);

    case 'mode2':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode2.fontSize, props.theme.typography.texts.mode2.lineHeight);

    case 'mode3':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode3.fontSize, props.theme.typography.texts.mode3.lineHeight);

    case 'mode4':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode4.fontSize, props.theme.typography.texts.mode4.lineHeight);

    case 'mode5':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode5.fontSize, props.theme.typography.texts.mode5.lineHeight);

    case 'mode6':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode6.fontSize, props.theme.typography.texts.mode6.lineHeight);

    case 'mode7':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode7.fontSize, props.theme.typography.texts.mode7.lineHeight);

    case 'mode8':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode8.fontSize, props.theme.typography.texts.mode8.lineHeight);

    case 'mode9':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode9.fontSize, props.theme.typography.texts.mode9.lineHeight);

    case 'mode10':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode10.fontSize, props.theme.typography.texts.mode10.lineHeight);

    case 'mode11':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode11.fontSize, props.theme.typography.texts.mode11.lineHeight);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts["default"].fontSize, props.theme.typography.texts["default"].lineHeight);
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 22152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

var useAppDispatch = function useAppDispatch() {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 66598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "useHandleWithGoogle": function() { return /* reexport */ useHandleWithGoogle; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__(86426);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
// EXTERNAL MODULE: ./store/slices/auth/index.ts + 1 modules
var auth = __webpack_require__(43685);
// EXTERNAL MODULE: ./lib/axios.ts
var axios = __webpack_require__(5272);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
;// CONCATENATED MODULE: ./lib/mutation/google/hook.ts










var useHandleWithGoogle = function useHandleWithGoogle(_ref) {
  var usagePurpose = _ref.usagePurpose,
      phone = _ref.phone;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  var keyRef = (0,react.useRef)('');

  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/auth/google/', args).then(function (res) {
      return res.data;
    });
  }),
      isErrorGoogle = _useMutation.isError,
      errorGoogle = _useMutation.error,
      isLoadingGoogle = _useMutation.isLoading,
      mutateAsync = _useMutation.mutateAsync;

  var _useQuery = (0,useQuery/* useQuery */.a)(['me', keyRef.current], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var queryKey, _yield$api$get, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryKey = _ref2.queryKey;
              _context.next = 3;
              return axios/* api.get */.h.get('/me', {
                headers: {
                  Authorization: "Token ".concat(queryKey[1])
                }
              });

            case 3:
              _yield$api$get = _context.sent;
              data = _yield$api$get.data;
              return _context.abrupt("return", data);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), {
    enabled: !!keyRef.current,
    onSuccess: function onSuccess(data) {
      dispatch((0,auth.addUser)({
        jwt: {
          access: "Token ".concat(keyRef.current),
          refresh: keyRef.current
        },
        data: data
      }));
      router.replace(routes/* HOME_ROUTE */.ef);
    }
  }),
      isErrorMe = _useQuery.isError,
      errorMe = _useQuery.error,
      isFetchingMe = _useQuery.isFetching;

  var handleGoogle = (0,index_esm/* useGoogleLogin */.Nq)({
    onSuccess: function () {
      var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(codeResponse) {
        var _yield$mutateAsync, key;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return mutateAsync({
                  accessToken: codeResponse.access_token,
                  usagePurpose: usagePurpose,
                  phone: phone
                });

              case 2:
                _yield$mutateAsync = _context2.sent;
                key = _yield$mutateAsync.key;
                keyRef.current = key;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onSuccess(_x2) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }(),
    onError: function onError(resErr) {
      console.error(resErr);
    }
  });
  return {
    handleGoogle: handleGoogle,
    loading: isLoadingGoogle || isFetchingMe,
    isError: isErrorMe || isErrorGoogle,
    error: errorMe || errorGoogle
  };
};
;// CONCATENATED MODULE: ./lib/mutation/google/index.ts



/***/ }),

/***/ 65866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sign_in; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./components/forms/sign-in-form/styles.ts


var SignInFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__SignInFormWrapper",
  componentId: "sc-18qo32j-0"
})(["width:80%;margin:0 auto;.sign-in-head{text-align:center;margin-bottom:24px;&-title{margin-bottom:24px;color:", ";}&-subtitle{letter-spacing:0.8px;color:", ";}&-err{background-color:rgba(255,0,0,0.1);border:1px solid ", ";width:80%;margin:0 auto;margin-top:24px;padding:8px;color:", ";}}.sign-in-form{&-submit{> button{border-radius:unset;}}&-google{}}.sign-in-forgot{margin:24px 0;display:flex;p{color:", ";opacity:0.8;}}.or-line{margin:24px 0;color:", ";display:flex;justify-content:space-between;align-items:center;> span{width:25%;border:1px solid ", ";}}.sign-in-google{> button{width:100%;height:58px;border:1px solid rgba(43,43,43,0.1) !important;display:flex;justify-content:center;align-items:center;box-shadow:unset !important;p{color:", ";}}}@media ", "{width:100%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayPallet1;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.red;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.red;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.green;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grayPallet1;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.whitePallet1;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.bluePallet1;
}, breakpoints/* device.tablet */.U.tablet);
// EXTERNAL MODULE: ./components/common/title/index.tsx
var title = __webpack_require__(51951);
// EXTERNAL MODULE: ./components/common/text/index.tsx
var common_text = __webpack_require__(96861);
// EXTERNAL MODULE: ./components/common/text-field/index.tsx
var text_field = __webpack_require__(80367);
// EXTERNAL MODULE: ./components/common/button/index.tsx
var common_button = __webpack_require__(57456);
// EXTERNAL MODULE: ./components/common/loader/index.tsx
var loader = __webpack_require__(6035);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./lib/axios.ts
var axios = __webpack_require__(5272);
;// CONCATENATED MODULE: ./lib/mutation/sign-in/hook.ts


var useSignIn = function useSignIn() {
  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/auth/login', args).then(function (res) {
      return res.data;
    });
  }),
      isError = _useMutation.isError,
      isLoading = _useMutation.isLoading,
      data = _useMutation.data,
      mutateAsync = _useMutation.mutateAsync,
      error = _useMutation.error;

  return {
    signIn: mutateAsync,
    isError: isError,
    isLoading: isLoading,
    data: data,
    error: error
  };
};
;// CONCATENATED MODULE: ./lib/mutation/sign-in/index.ts


// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
// EXTERNAL MODULE: ./store/slices/auth/index.ts + 1 modules
var auth = __webpack_require__(43685);
// EXTERNAL MODULE: ./components/common/text-field-password/index.tsx
var text_field_password = __webpack_require__(93546);
// EXTERNAL MODULE: ./utils/validations.ts + 1 modules
var validations = __webpack_require__(87023);
// EXTERNAL MODULE: ./components/layout/auth-layout/styles.ts
var styles = __webpack_require__(70296);
// EXTERNAL MODULE: ./lib/mutation/google/index.ts + 1 modules
var google = __webpack_require__(66598);
// EXTERNAL MODULE: ./components/common/error/index.tsx
var common_error = __webpack_require__(89925);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/forms/sign-in-form/index.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























function SignInForm() {
  var _error$response, _errGoogle$response;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  var router = (0,next_router.useRouter)();

  var _useSignIn = useSignIn(),
      isError = _useSignIn.isError,
      isLoading = _useSignIn.isLoading,
      signIn = _useSignIn.signIn,
      error = _useSignIn.error;

  var _useHandleWithGoogle = (0,google.useHandleWithGoogle)({}),
      errGoogle = _useHandleWithGoogle.error,
      isErrGoogle = _useHandleWithGoogle.isError,
      loading = _useHandleWithGoogle.loading,
      handleGoogle = _useHandleWithGoogle.handleGoogle;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    resolver: (0,yup/* yupResolver */.X)(validations/* signInSchema */.wL)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var _yield$signIn, user, jwt;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return signIn({
                identifier: data.signInEmail,
                password: data.signInPassword
              });

            case 3:
              _yield$signIn = _context.sent;
              user = _yield$signIn.user;
              jwt = _yield$signIn.jwt;
              dispatch((0,auth.addUser)({
                data: user,
                jwt: _objectSpread(_objectSpread({}, jwt), {}, {
                  access: "Bearer ".concat(jwt.access)
                })
              }));
              router.replace(routes/* HOME_ROUTE */.ef);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error('Unknown Err');

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var signWithGoogle = (0,react.useCallback)(function () {
    handleGoogle();
  }, [handleGoogle]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* AuthContent */.p, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SignInFormWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "sign-in-head",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
          fw: "bold",
          type: "mode1",
          className: "sign-in-head-title",
          children: "Sign In to Richr"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          fw: "light",
          className: "sign-in-head-subtitle",
          children: "Enter your details below"
        }), isError && /*#__PURE__*/(0,jsx_runtime.jsx)(common_error/* default */.Z, {
          data: error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.errors
        }), isErrGoogle && /*#__PURE__*/(0,jsx_runtime.jsx)(common_error/* default */.Z, {
          data: errGoogle === null || errGoogle === void 0 ? void 0 : (_errGoogle$response = errGoogle.response) === null || _errGoogle$response === void 0 ? void 0 : _errGoogle$response.data.errors
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "sign-in-form",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
          type: "text",
          name: "signInEmail",
          label: "Email",
          register: register,
          error: errors.signInEmail,
          placeholder: "Enter your email"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field_password/* default */.Z, {
          type: "password",
          name: "signInPassword",
          label: "Password",
          register: register,
          error: errors.signInPassword,
          placeholder: "Enter your password"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "sign-in-forgot",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: routes/* FORGOT_PASSWORD_ROUTE */.Fb,
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                fw: "light",
                children: "Forgot password?"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "sign-in-form-submit",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_button/* Button */.z, {
            type: "submit",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
              type: "mode3",
              textTransform: "uppercase",
              children: "Sign In"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
        className: "or-line",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), "or", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sign-in-google",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(common_button/* Button */.z, {
          mode: "google",
          className: "sign-in-form-google",
          onClick: signWithGoogle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/icons/google.svg",
            width: 24,
            height: 24
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "Continue with Google"
          })]
        })
      }), (isLoading || loading) && /*#__PURE__*/(0,jsx_runtime.jsx)(loader/* PageLoader */.w, {})]
    })
  });
}

/* harmony default export */ var sign_in_form = (/*#__PURE__*/(0,react.memo)(SignInForm));
// EXTERNAL MODULE: ./components/layout/auth-layout/index.tsx
var auth_layout = __webpack_require__(72943);
;// CONCATENATED MODULE: ./pages/auth/sign-in/index.tsx






function SignInPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(auth_layout/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Sign-In"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(sign_in_form, {})]
  });
}

/* harmony default export */ var sign_in = (SignInPage);

/***/ }),

/***/ 87023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rw": function() { return /* binding */ createPasswordSchema; },
  "Hj": function() { return /* binding */ forgotSchema; },
  "iK": function() { return /* binding */ homeValuationSchema; },
  "Ci": function() { return /* binding */ listPriceSchema; },
  "pJ": function() { return /* binding */ listingPriceSchema; },
  "EX": function() { return /* binding */ listingPropertyDetailsSchema; },
  "PM": function() { return /* binding */ listingPropertyTypeSchema; },
  "Tb": function() { return /* binding */ listingSchema; },
  "wL": function() { return /* binding */ signInSchema; },
  "JJ": function() { return /* binding */ signUpSchema; },
  "aF": function() { return /* binding */ signUpWithGoogleSchema; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./utils/regex.ts
var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
var PASSWORD_REGEX = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[~`!@#$%^&*()--+=§±]){1,})(?!.*\s).{8,}$/;
var ONLY_TEXT = /^[A-Za-z]*$/;
var TEXT_WITH_SPACES = /^[A-Za-z ]*$/;
;// CONCATENATED MODULE: ./utils/validations.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // @TODO: Replace the `This field is Required` occurences with the below const.

var requiredFieldErrorMessage = 'This field is Required';
var inalidValueErrorMessage = 'Invalid value';
var signInSchema = es/* object */.Ry().shape({
  signInEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required'),
  signInPassword: es/* string */.Z_().min(8, 'Password is too short - should be 8 chars minimum.').required('This field is Required')
}).required();
var signUpSchema = es/* object */.Ry().shape({
  signUpEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required'),
  signUpFirstName: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid First Name').required('This field is Required'),
  signUpLastName: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid Last Name').required('This field is Required'),
  signUpPhone: es/* string */.Z_().min(10, 'Invalid Phone number').required('This field is Required'),
  signUpPassword: es/* string */.Z_().matches(PASSWORD_REGEX, "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum.").required('This field is Required'),
  signUpUsagePurpose: es/* string */.Z_().required('This field is Required')
}).required();
var signUpWithGoogleSchema = es/* object */.Ry().shape({
  signUpGoogleUsagePurpose: es/* string */.Z_().required('This field is Required'),
  signUpGooglePhone: es/* string */.Z_().required('This field is Required')
}).required();
var listPriceSchema = es/* object */.Ry().shape({
  listPrice: es/* string */.Z_().required('This field is Required'),
  agentCommission: es/* string */.Z_().required('This field is Required')
}).required();
var forgotSchema = es/* object */.Ry().shape({
  forgotEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required')
}).required();
var createPasswordSchema = es/* object */.Ry().shape({
  createPassword: es/* string */.Z_().matches(PASSWORD_REGEX, "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum.").required('This field is Required'),
  createPasswordConfirm: es/* string */.Z_().oneOf([es/* ref */.iH('createPassword'), null], 'Passwords must match')
}).required();
var leadSchemaShape = {
  address: es/* string */.Z_().required(requiredFieldErrorMessage),
  email: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email').required(requiredFieldErrorMessage),
  phone_number: es/* string */.Z_().min(10, 'Invalid Phone number').required(requiredFieldErrorMessage)
};
var listingSchema = es/* object */.Ry().shape(_objectSpread(_objectSpread({}, leadSchemaShape), {}, {
  name: es/* string */.Z_().matches(TEXT_WITH_SPACES, 'Invalid Name').required(requiredFieldErrorMessage),
  is_open_to_buy: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage)
})).required();
var homeValuationSchema = es/* object */.Ry().shape(_objectSpread(_objectSpread({}, leadSchemaShape), {}, {
  first_name: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid First Name').required(requiredFieldErrorMessage),
  last_name: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid Last Name').required(requiredFieldErrorMessage)
})).required();
var listingPropertyTypeSchema = es/* object */.Ry().shape({
  property_type: es/* string */.Z_().required(requiredFieldErrorMessage),
  is_waterfront_property: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage),
  has_swimming_pool: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage)
}).required();
var listingPropertyDetailsSchema = es/* object */.Ry().shape({
  bed_count: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).transform(function (_, val) {
    return val ? Number(val) : null;
  }).nullable(),
  bath_count: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }),
  home_area: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  })
}).required(); // @TODO: Check edge cases for validations

var listingPriceSchema = es/* object */.Ry().shape({
  desired_price: es/* number */.Rx().required(requiredFieldErrorMessage).min(1, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }),
  buyer_agent_commission: es/* number */.Rx().min(0, 'Please enter a number from 0 to 3.').max(3, 'Please enter a number from 0 to 3.').nullable().transform(function (_, val) {
    return (0,lodash.isNaN)(val) ? null : Number(val);
  }),
  home_valuation_price: es/* number */.Rx().min(0, inalidValueErrorMessage).nullable()
}).required();

/***/ }),

/***/ 70149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-in",
      function () {
        return __webpack_require__(65866);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,7536,8074,9491,7848,2486,9774,2888,179], function() { return __webpack_exec__(70149); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);